import * as S from 'components/Company/EarningsReportsList/PoweredByQuartrStyles';
import CustomLink from 'components/Globals/Base/Link';
import getEarningReportPageTestId from 'constants/testsIds/earningsReportPage';

const PoweredByQuartr = () => (
  <S.Container>
    <S.PoweredBy data-cy={getEarningReportPageTestId('POWERED_BY')}>Powered by</S.PoweredBy>
    <CustomLink
      href='https://quartr.com/products/quartr-api'
      rel='nofollow'
      target='_blank'
      className='link'
      data-cy={getEarningReportPageTestId('QUARTR_ICON')}
    >
      <svg
        width='69'
        height='19'
        viewBox='0 0 69 19'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        aria-label='Go to Quartr'
        role='img'
      >
        <title>Quartr</title>
        <g
          id='Quartr logo 1'
          clipPath='url(#clip0_4709_27048)'
        >
          <path
            id='Vector'
            d='M5.19385 13.9922C5.19385 16.4758 8.90619 18.4893 11.7744 18.4893C13.3003 18.4893 14.6726 17.9195 15.6229 17.012L11.7744 13.9922H5.19385Z'
            fill='black'
          />
          <path
            id='Vector_2'
            d='M0 13.9932C0 16.4769 2.32527 18.4904 5.19353 18.4904V9.49609C2.32527 9.49609 0 11.5095 0 13.9932Z'
            fill='black'
          />
          <path
            id='Vector_3'
            d='M11.7741 4.99718V12.8707H16.9676V5.00842C16.9622 2.51018 14.6393 0.493891 11.7741 0.500014H5.14308V0.500514C2.29813 0.524129 0 2.52818 0 4.99718V9.49433H5.19353V4.99718H11.7741Z'
            fill='black'
          />
          <path
            id='Vector_4'
            d='M12.6777 13.6875L18.341 18.0057V13.6875H12.6777Z'
            fill='black'
          />
          <path
            id='Vector_5'
            d='M39.9321 11.7915H39.9136C39.5422 13.5552 38.4098 14.3535 36.8874 14.3535C34.6411 14.3535 33.8613 12.8682 33.8613 11.0117V5.46094H35.4765V10.6034C35.4765 11.7915 35.9963 12.8682 37.5559 12.8682C39.0409 12.8682 39.9321 12.0515 39.9321 10.6034V5.46094H41.5473V14.1307H39.9321V11.7915Z'
            fill='black'
          />
          <path
            id='Vector_6'
            d='M48.2776 10.9027V10.4941H45.697C44.6016 10.4941 44.0076 10.9027 44.0076 11.6637C44.0076 12.3321 44.4348 12.9632 45.697 12.9632C47.2937 12.9632 48.2776 12.0908 48.2776 10.9027ZM48.2776 11.9237H48.2592C47.8693 13.5202 46.6993 14.3186 45.1956 14.3186C43.5063 14.3186 42.4111 13.5017 42.4111 11.868C42.4111 10.3457 43.3764 9.21315 45.4744 9.21315H48.2776V8.74897C48.2776 7.39379 47.7578 6.65123 46.3841 6.65123C45.1403 6.65123 44.4533 7.22666 44.2118 8.65616L42.6709 8.4334C42.9679 6.40981 44.156 5.27734 46.4394 5.27734C48.8532 5.27734 49.8928 6.50262 49.8928 8.73045V14.1329H48.2776V11.9237Z'
            fill='black'
          />
          <path
            id='Vector_7'
            d='M50.7773 14.1307V5.46094H52.3925V8.1342H52.4298C52.7824 6.11061 53.5994 5.46094 54.992 5.46094H55.5302V7.24298H54.7505C53.1169 7.24298 52.3925 7.8743 52.3925 9.54514V14.1307H50.7773Z'
            fill='black'
          />
          <path
            id='Vector_8'
            d='M57.6727 6.84966L56.3916 7.2669V5.45725H57.6727V3.0625H59.2878V5.45725H62.0541V7.25351L59.2878 6.84966V11.3238C59.2878 12.2893 59.6593 12.7905 60.6247 12.7905C61.0887 12.7905 61.4786 12.6977 61.9426 12.5677L62.1468 14.0529C61.5528 14.2385 61.0887 14.35 60.2906 14.35C58.4713 14.35 57.6727 13.1619 57.6727 11.5466V6.84966Z'
            fill='black'
          />
          <path
            id='Vector_9'
            d='M63.019 14.1307V5.46094H64.6342V8.1342H64.6711C65.0241 6.11061 65.8407 5.46094 67.2332 5.46094H67.7715V7.24298H66.9918C65.3582 7.24298 64.6342 7.8743 64.6342 9.54514V14.1307H63.019Z'
            fill='black'
          />
          <path
            id='Vector_10'
            d='M31.67 9.09891C31.67 6.80518 30.029 5.01712 27.8342 5.01712C25.6393 5.01712 23.8627 6.80518 23.8627 9.09891C23.8627 11.5191 25.6073 12.9648 27.8342 12.9648C30.061 12.9648 31.67 11.5191 31.67 9.09891ZM22.3887 9.117C22.3887 5.88402 24.8544 3.5 27.8342 3.5C30.8301 3.5 33.1438 5.88402 33.1438 9.117C33.1438 11.0314 32.2154 12.3689 31.0299 13.3802L32.4076 15.8908V15.9269H30.7896L29.8444 14.1208C29.2837 14.3374 28.523 14.464 27.8342 14.464C24.7902 14.464 22.3887 12.3318 22.3887 9.117Z'
            fill='black'
          />
        </g>
        <defs>
          <clipPath id='clip0_4709_27048'>
            <rect
              width='68.0488'
              height='18'
              fill='white'
              transform='translate(0 0.5)'
            />
          </clipPath>
        </defs>
      </svg>
    </CustomLink>
  </S.Container>
);

export default PoweredByQuartr;
